import { render } from "./custom-preview.vue?vue&type=template&id=f16fa5b0&lang=pug"
import script from "./custom-preview.vue?vue&type=script&lang=js"
export * from "./custom-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__